import { useEffect, useState } from "react";
import {
  getSiteContent,
  rehydrateSiteContentAdmin,
  rehydrateSiteContentPublic,
  saveSiteContent,
  subscribeSiteContent,
  type SiteContentState,
} from "../lib/siteContentStore";

export function usePublicSiteContent() {
  const [content, setContent] = useState<SiteContentState>(() => getSiteContent());

  useEffect(() => {
    void rehydrateSiteContentPublic();
    return subscribeSiteContent(() => setContent(getSiteContent()));
  }, []);

  return content;
}

export function useAdminSiteContent() {
  const [content, setContent] = useState<SiteContentState>(() => getSiteContent());

  useEffect(() => {
    void rehydrateSiteContentAdmin();
    return subscribeSiteContent(() => setContent(getSiteContent()));
  }, []);

  return { content, saveSiteContent, rehydrateSiteContentAdmin };
}
